const CUSTOM_ELEMENT_ID = "banner-slider-content";
const CLASS_HIDDEN = "hidden";

class BannerSliderContent extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector(".item-list");
    this.elements = this.querySelectorAll(".list-item");
    this.firstListElement = this.list.firstElementChild;
    this.lastListElement = this.list.lastElementChild;
    this.buttonPrevious = this.querySelector(".control[data-direction='prev']");
    this.buttonNext = this.querySelector(".control[data-direction='next']");
    this.tabContainer = this.querySelector(".tab-navigation");
    this.tabs = this.querySelectorAll(".tab");
    this.loopInterval = null;

    this.isRotating = true;
    this.buttonRotation = this.querySelector(".button-rotation");
    this.buttonRotationIcon = this.querySelector(".icon-rotation");
    this.buttonRotationText = this.querySelector(".button-rotation--text");

    // Animiertes Bild
    this.slideAnimation = this.querySelector(".list-item:first-of-type .slide-animation:not(.halfsize)");
    
    // Video
    this.videos = this.querySelectorAll(".videoplayer");
}

get singleEntryWidth() {
    const element = this.list.firstElementChild;
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    const breite = element.offsetWidth;
    const margin = parseFloat(elementStyle.marginRight) + parseFloat(elementStyle.marginLeft);
    const border = parseFloat(elementStyle.borderRightWidth) + parseFloat(elementStyle.borderLeftWidth);
    return breite + margin + border;
}

get activeTab() {
    return this.querySelector(".tab[active]");
}

disconnectedCallback() {
    // Aufräumen
}

connectedCallback() {
    this.initControls();
    this.initBannerObserver();
    if(this.elements.length > 1) {
        this.initRotationButton();
    }
    // Wenn Rotation auf "gestartet"
    if(this.isRotating === true) {
        this.startRotation(false);
        this.startAnimation();
        this.startVideo();
    } else {
        this.stopRotation(false);
        this.stopAnimation();
        this.stopVideo();
    }
    this.checkFocus();
  }

  initBannerObserver() {
    const callback = (entries, observer) => this.bannerObserverCallback(entries, observer);
    this.startIntersectionObserver(this.elements, callback);
  }

  startIntersectionObserver(observables, callback) {
    if (!observables || !callback) return;
    const options = {
      root: this,
      threshold: [0.9, 0.95, 1.0]
    };
    const observer = new IntersectionObserver(callback, options);
    if (!observables.length) {
      observer.observe(observables);
    } else {
      for (const element of observables) {
        observer.observe(element);
      }
    }
    return observer;
  }

  bannerObserverCallback(entries, observer) {
    for (const entry of entries) {
      const { target, intersectionRatio } = entry;
      const entryFullyVisible = intersectionRatio >= 0.9;
      const position = target.dataset["position"];
      if (entryFullyVisible) {
        this.setActiveTab(position);
      }
    }
  }

  setActiveTab(position) {
    // Entferne den "active" Status und den Text von allen Tabs
    const allTabs = this.querySelectorAll('.tab');
    allTabs.forEach(tab => {
      tab.removeAttribute("active");
      tab.textContent = tab.textContent.replace(" ist ausgewählt", ""); // Entferne den Text
    });

    // Setze den aktiven Tab
    const activeTab = this.querySelector(`.tab[data-position="${position}"]`);
    if (activeTab) {
      activeTab.setAttribute("active", "");
      activeTab.textContent += " ist ausgewählt"; // Füge den Text hinzu
    }
  }

  async initControls(controlsHidden = false) {
    const controlElements = [this.buttonNext, this.buttonPrevious];
    for (const control of controlElements) {
      if (!controlsHidden && this.elements.length > 1) {
        this.showKontrollelement(control);
      } else {
        this.hideKontrollelement(control);
      }
      control.addEventListener("click", (event) => {
        this.controlClickHandler(event);
        this.stopLoop();
      });
    }
  }

  showKontrollelement(element) {
    element.classList.remove(CLASS_HIDDEN);
  }
  
  hideKontrollelement(element) {
    element.classList.add(CLASS_HIDDEN);
  }
  
  controlClickHandler(event) {
    // Hier verwenden wir event.currentTarget, um den Button selbst zu referenzieren
    const direction = event.currentTarget.dataset["direction"];
    
    // Wenn der nächste Button gedrückt wird und das letzte Element erreicht ist, gehe zurück zum ersten Element
    if (direction === "next" && this.list.scrollLeft + this.singleEntryWidth >= this.list.scrollWidth - 1) {
        this.scrollToPosition(0); // Zurück zum ersten Element
    } 
    // Wenn der vorherige Button gedrückt wird und das erste Element erreicht ist, gehe zum letzten Element
    else if (direction === "prev" && this.list.scrollLeft === 0) {
        const lastPosition = this.list.scrollWidth - this.singleEntryWidth; // Berechne die Position des letzten Elements
        this.scrollToPosition(lastPosition); // Gehe zum letzten Element
    } 
    else {
        this.updateBannerSliderPosition(direction);
    }
  }

  updateBannerSliderPosition(direction, multiplier = 1) {
    const left = (direction === "next" ? this.singleEntryWidth : - this.singleEntryWidth) * multiplier;
    this.scrollToPosition(this.list.scrollLeft + left);
  }

  scrollToPosition(positionLeft) {
    this.list.scrollTo({
      left: positionLeft,
      behavior: "smooth"
    });
  }

  stopLoop() {
    clearInterval(this.loopInterval);
  }

  loop() {
    this.loopInterval = setInterval(() => {
      if (this.activeTab) {
        const nextTab = (this.activeTab.dataset.position) % this.tabs.length;
        this.updateBannerSliderPosition("next");
        if (nextTab === 0) {
          this.scrollToPosition(0);
          this.stopRotation(false);
        }
      }
    }, 8000);
  }
    
    // Rotation
    initRotationButton() {
        this.buttonRotation.classList.remove('hidden');
        this.buttonRotation.addEventListener("click", () => {
            if (this.isRotating) {
                this.stopRotation(true);
                this.stopAnimation();
                this.stopVideo();
            } else {
                this.startRotation(true);
                this.startAnimation();
                this.startVideo();
            }
        });
    }

    // Rotation stoppen
    stopRotation() {
        this.stopLoop(); // Rotation stoppen
        this.buttonRotationIcon.classList.remove("element-icon-pause"); // Icons tauschen
        this.buttonRotationIcon.classList.add("element-icon-play");
        this.buttonRotationText.innerText = "Rotation gestoppt. Klicken, um Rotation zu starten"; // Text ändern
        this.isRotating = false; // Status setzen
    }

    // Rotation starten
    startRotation() {
        this.loop(); // Rotation starten
        this.buttonRotationIcon.classList.remove("element-icon-play"); // Icons tauschen
        this.buttonRotationIcon.classList.add("element-icon-pause");
        this.buttonRotationText.innerText = "Rotation gestartet. Klicken, um Rotation zu stoppen"; // Text ändern
        this.isRotating = true; // Status setzen
    }

    // Animation auf dem ersten Slide anhalten
    stopAnimation() {
        if(this.slideAnimation) {
            this.slideAnimation.style.setProperty("animation", "none");
        }
    }

    // Animation auf dem ersten Slide starten
    startAnimation() {
        if(this.slideAnimation) {
            this.slideAnimation.style.setProperty("animation", "banner-slider-content-zoom-in-out 40s linear infinite");
        }
    }

    // Video stoppen
    stopVideo() {
        this.videos.forEach(video => {
            video.pause();
        });
    }

    // Video starten
    startVideo() {
        this.videos.forEach(video => {
            video.play();
        });
    }

    // Funktion zur Überprüfung des Tastaturfokus auf die Links in der Liste
    checkFocus() {
        const listItems = this.querySelectorAll('.item-list .list-item a'); // Alle Links in der Liste

        listItems.forEach(link => {
            link.addEventListener('focus', () => {
                this.stopRotation(true);
                this.stopAnimation();
                this.stopVideo();
            });

        });
    }

}

if (!customElements.get(CUSTOM_ELEMENT_ID)) {
  customElements.define(CUSTOM_ELEMENT_ID, BannerSliderContent);
}
